import React from "react";
import "./styles.scss";
import { GetIconByName } from "../../config/icon";
import { GiClick } from "react-icons/gi";
import {Popconfirm} from "antd";

const AddCampaignCard = (props) => {

  const onClickCancel = (e) => {
    console.log(e);
  };

  return (
    <>
      <div
        className={`hne-campaign-card-wrapper ${
          props.isSelect ? "active" : ""
        }`}
      >
        <div className="accw-title">Campaign name</div>
        <div className="accw-name">{props.name}</div>
        <div className="accw_status"> {props.status}</div>
        <div className="accw-exp-date">expired on: {props.expDate}</div>
        <div className="accw-tag-wrapper d-flex flex-column mb-1">
          <div className="d-flex flex-row" style={{ gap: "12px"}}>
            <div className="accw-days">{props.days} days</div>
            <div className="accw-views-tag">
              <div className="vt-count">{props.views}</div>
              <div className="vt-icon">{GetIconByName("eye")}</div>
            </div>
            <div className="accw-views-tag">
              <div className="vt-count">{props.clicks}</div>
              <div className="vt-icon">{<GiClick />}</div>
            </div>
          </div>
            <div className="d-flex flex-row" style={{ gap: "12px"}}>
              <div className="accw-edit-tag" onClick={props.onClick}>
                {props.edit}
              </div>
              <Popconfirm
                  placement="topLeft"
                  title="Deactivate the advertisement"
                  description="Are you sure to deactivate this advertisement?"
                  onConfirm={props.onClickDeactivate}
                  onCancel={onClickCancel}
                  okText="Yes"
                  cancelText="No"
              >
                <div className="accw-edit-tag">
                  Deactivate
                </div>
              </Popconfirm>

              <Popconfirm
                  placement="topLeft"
                  title="Delete the advertisement"
                  description="Are you sure to delete this Advertisement?"
                  onConfirm={props.onClickDelete}
                  onCancel={onClickCancel}
                  okText="Yes"
                  cancelText="No"
              >
                <div className="accw-edit-tag">
                  Delete
                </div>
              </Popconfirm>
            </div>
        </div>
      </div>
    </>
  );
};
export default AddCampaignCard;
